import { colors } from "./color";

export const theme: themeType = {
  colors: {
    text: colors.black,
    subtitle: colors.lightGray,
    background: colors.whitesmoke,
    foreground: colors.white,
    black: colors.black,
  },
  breakpoints: {
    sm: "(max-width: 640px)",
    md: "(max-width: 768px)",
    lg: "(min-width: 1024px)",
    width: {
      sm: "(max-width: 640px)",
      md: "(max-width: 768px)",
      lg: "(min-width: 1024px)",
    }, 
    height: {
      sm: "(max-height: 800px)", 
      md: "(max-height: 1024px)",
      lg: "(min-height: 1280px)",
    }
  },
};

type themeType = {
  colors: {
    text: string;
    subtitle: string;
    background: string;
    foreground: string;
    black: string;
  };
  breakpoints: {
    sm: string;
    md: string;
    lg: string;
    width: {
      sm: string;
      md: string;
      lg: string;
    };
    height: {
      sm: string;
      md: string;
      lg: string;
    }
  };
};
